export default __webpack_public_path__ + "static/field-to-family-0cdb91415b522a87d9a50ede5537e17a.png";